// GENERATED FILE — do not edit. Source of truth: agents/shared/. Sync: node scripts/sync-agent-shared.mjs
// DefectSnap Form Schema v2 — the canonical, relation-aware form definition.
// Single source of truth shared by the agent service (Node) and the frontend
// (synced copy via scripts/sync-agent-shared.mjs). Plain ESM JS + .d.ts so both
// runtimes consume it without a build step.
//
// Extends the legacy ReportSchema (v1: sections -> fields with primitive
// dataType) with rich field types, options (response sets), conditional logic
// (dependsOn / visibleWhen with effects — the SafetyCulture "smart field"
// pattern) and cross-field relations in OpenAPI style: xor (exactly one),
// union/anyOf (at least one), allOf (all together), dependsOn.

export const FORM_SCHEMA_VERSION = 2;

export const FIELD_TYPES = [
  'text', 'textarea', 'number', 'boolean', 'select', 'multiselect',
  'rating', 'date', 'datetime', 'photo', 'signature', 'gps', 'instruction',
];

export const CONDITION_OPS = ['eq', 'neq', 'in', 'gt', 'gte', 'lt', 'lte', 'answered', 'notAnswered'];

export const EFFECTS = ['require', 'requireNote', 'requirePhoto', 'requireAction'];

export const RELATION_TYPES = ['xor', 'union', 'allOf', 'dependsOn'];

// Structural block kinds: a plain section, a report page (page break in the
// PDF), or a table (fields are columns; inspection rows repeat them).
export const SECTION_KINDS = ['section', 'page', 'table'];
export const MAX_TABLES = 5;

// Story 4-110 — per-section page-flow control (`contracts/reports.js
// #ReportContentSection.pageBreak`'s own comment has the full rationale).
// A plain field any section (any `kind`) can carry, editable after
// creation — replaces the old `kind:'page'` + global `content.pageBreak`
// toggle double-gate, which could only be set once at creation and never
// revisited. 'always' = force a fresh page before this block (today's
// `kind:'page'` behavior); 'avoid' = glue to the previous block; 'auto'
// (default) = flow normally.
export const PAGE_BREAKS = ['auto', 'always', 'avoid'];

// Story 4-114 — "hide a section from the report without removing it from
// capture" / "reorder report sections independently from capture order".
// Both are plain fields any TEMPLATE section can carry, mirroring
// `pageBreak`'s own precedent immediately above: additive, editable
// post-creation, resolved with a null-safe fallback everywhere a missing
// value can occur (a pre-4-114 section has neither key at all).
//   * `hidden` (boolean, default false) — when true, the section is dropped
//     BEFORE it ever reaches the render model: `inspectionAnswers.service.js
//     #buildReportAnswerView` and `report.service.js#tableOfContentsOf` both
//     filter it out via `orderedVisibleReportSections` below, so a hidden
//     section consumes zero pagination space and never appears in the TOC —
//     not merely styled as hidden, genuinely absent from both renderers'
//     input. The underlying template section (its fields, its captured
//     answers) is completely untouched; only report OUTPUT is affected.
//   * `reportOrder` (number, nullable, default null) — a section's position
//     among the report's OWN section list, independent of `schema.sections`'
//     own array order (which stays the capture order forever — the array
//     itself is never reordered, only this field changes). `null` means "no
//     explicit report order set yet", which `orderedVisibleReportSections`
//     resolves to the section's own capture-order index, so a template that
//     never reorders anything renders in capture order exactly as before
//     this story.
export const PAGE_ORIENTATIONS = ['portrait', 'landscape'];
export const MARGIN_PRESETS = ['narrow', 'normal', 'wide'];

// Story 4-116 — Section Presentation Tools: 8 additive per-section report
// properties, siblings to `pageBreak`/`hidden`/`reportOrder` above (same
// "plain field any section can carry, resolved with a documented default
// when missing" pattern). `pageBreak` itself is this story's own 9th
// property but needed no new field — it already exists, just gets a UI here
// (`ReportStudioPanels.tsx`).
//
//   * `layout` — how the section's rows render. 'list' (default) is TODAY's
//     only behavior, unchanged (a plain <dl> of label/value rows). 'table'
//     is not an independent author choice: a `kind:'table'` section (real
//     repeating rows) is ALWAYS resolved to 'table' regardless of what is
//     stored, and a non-table section can never resolve to 'table' either
//     (there is no repeating row data to build one from) —
//     `resolveSectionPresentation` below enforces both directions.
//     'groupedList' has no grouping key in the capture model yet (fields
//     carry no group/category of their own) — the stored value is preserved
//     for round-tripping, but resolved DOWN to 'list' at render time
//     (defensive fallback; the UI's own job is to never let an author
//     choose it in the first place). 'summaryCards'/'narrative' are real,
//     rendered new layouts (see both renderers).
//   * `columns` — 'one' (default, unchanged) or 'two', meaningful for the
//     'list' layout only (resolved to 'one' for every other layout — a
//     table already has its own column structure, and narrative/summary-
//     cards lay out their own way regardless).
//   * `density` — 'comfortable' (default, today's unchanged spacing),
//     'compact', 'condensed' — real, rendered spacing presets, the
//     per-section sibling `headingScale`/`thumbnailSize` already established
//     at the report-wide level.
//   * `heading` — 'visible' (default, unchanged), 'hidden', 'renamed'
//     (paired with `headingLabel`), 'numbered' (prefixes the section's
//     1-based report-order position, e.g. "3. Roof").
//   * `headingLabel` — only consulted when `heading === 'renamed'`; a
//     blank/missing value falls back to the section's own template name (an
//     honest default, not a disabled state — the heading still renders,
//     just not customized yet).
//   * `repeatHeading` — 'table' sections only (`false` default: today's
//     unchanged behavior — a table section never spans a page boundary,
//     `.report-section`'s own unconditional `break-inside:avoid`). `true`
//     opts a table INTO spanning pages with its header repeated on each one
//     — see `frontend/src/report-document/styles/document.css` for the real
//     CSS mechanism (story 4-128f: it used to be described here as living in
//     `pdfExport.service.js`, which no longer renders anything). Resolved to `false`
//     for a non-table section (nothing to repeat).
//   * `showEmpty` — 'show' (default, unchanged: an empty value renders as
//     an empty cell), 'hide' (the row is dropped entirely), 'notProvided'
//     (renders the literal text "Not provided").
//   * `evidencePlacement` — 'inline' (default, unchanged: a photo-type
//     row's grid renders in place, wherever that row falls). 'afterResponse'
//     (each photo-bearing row's own grid moves to a block immediately after
//     that row, still per-row). 'gallery' (every photo in the section is
//     pooled into ONE grid at the end of the section). 'appendix' — REALIZED
//     as of story 4-117: the section's photos are pooled into a report-level
//     "Supporting documents" block at the very end of the document (after
//     every other content-tab block, including the disclaimer), stripped out
//     of the section's own rows the same way 'gallery' strips them into a
//     per-section pool. See `report-document/ReportDocument.tsx#appendix
//     PhotosOf` for the pooling logic — story 4-128f: there is no longer a
//     backend "twin" of it. It is derived at RENDER time from
//     `section.rows`/`.presentation`,
//     the same "no wire shape change needed" approach 'gallery' already
//     established, so a pre-4-117 frozen `assembledContent` snapshot (which
//     can never have chosen 'appendix' — the UI did not offer it) is
//     unaffected.
//   * `findingEmphasis` — 'standard' (default; today's unchanged behavior —
//     findings are not associated with their originating section in this
//     report's data model at all, `contracts/reports.js#ReportFindingRollup
//     Item` carries no section reference, so 'highlighted'/'summaryOnly'
//     have nothing to act on yet) is the ONLY realized value; the other two
//     are resolved DOWN to 'standard' at render time, same defensive-
//     fallback shape as the two above.
//
// Story 4-118 — Table Tools: 3 more additive properties, `kind:'table'`
// sections only (same "resolved down to a real, harmless default for a
// section this doesn't apply to" pattern `repeatHeading` already
// established immediately above).
//   * `tableColumns` — select/reorder visible columns + semantic emphasis,
//     ALL THREE in one ordered list rather than three separate fields: each
//     entry is `{ key, visible, emphasis }`, `key` a table field's own
//     `field.key` (stable across a label rename, unlike matching on the
//     column's display label), array order IS display order. `null`/missing
//     (every table before this story) resolves to "every current field,
//     capture order, visible, standard emphasis" — today's unchanged
//     rendering, byte-identical. See `resolveTableColumns` below for how a
//     stored list that has drifted from the section's CURRENT field list
//     (a field added/removed since the list was saved) is reconciled: a
//     stale key is dropped, a new field is appended visible-by-default
//     rather than silently vanishing from the table. `emphasis` is a named
//     level, not a pixel width — `'standard'` (default, no width steer),
//     `'primary'` (wider), `'secondary'` (unchanged width), `'compact'`
//     (narrower) — resolved to real CSS by both renderers off this one enum,
//     never a free-form size. Resolved to `null` for a non-table section
//     (nothing to select/reorder).
//   * `overflow` — `'wrap'` (default; today's unconstrained behavior — a
//     cell's text wraps within its natural width) or `'truncate'` (a text
//     cell's value clips to one line with the FULL value still present in
//     the cell's own markup/PDF text layer — see both renderers' own
//     comments at their truncation CSS for the exact mechanism and the live
//     Puppeteer/`pdftotext` verification it required). Resolved to `'wrap'`
//     for a non-table section (the concept is table-cell-specific per this
//     story's own brief).
//   * `showTotalsRow` — `false` default (today's unchanged behavior: no
//     summary row). `true` appends one aggregate row, computed at RENDER
//     time by `computeTableTotalsRow` below from the table's own resolved
//     rows (no new wire field — same "derived at render time from rows +
//     presentation" approach `evidencePlacement:'gallery'`/`'appendix'`
//     already established) — a numeric column sums, a chip column counts
//     each distinct label (a lightweight compliance/status summary), a
//     photo-grid column counts total photos, anything else renders blank
//     except the first column (`"Total (N rows)"`, an anchor label). Resolved
//     to `false` for a non-table section (nothing to total).
// `resolveTableColumnEmphasisView` below additionally guards emphasis
// `'compact'` against a column that carries `photo-grid`/`chip` cells
// (actions/signatures/images) — automatically relaxed to `'secondary'`
// rather than letting an author compress evidence into an unusable sliver;
// this is a RENDER-time safety rule, not a fourth stored property, so it can
// never be bypassed by a hand-edited or agent-plane value either.
export const SECTION_LAYOUTS = ['list', 'groupedList', 'table', 'summaryCards', 'narrative'];
export const SECTION_COLUMNS = ['one', 'two'];
export const SECTION_DENSITIES = ['comfortable', 'compact', 'condensed'];
export const SECTION_HEADING_MODES = ['visible', 'hidden', 'renamed', 'numbered'];
export const SHOW_EMPTY_MODES = ['show', 'hide', 'notProvided'];
export const EVIDENCE_PLACEMENTS = ['inline', 'afterResponse', 'gallery', 'appendix'];
export const FINDING_EMPHASES = ['standard', 'highlighted', 'summaryOnly'];
export const TABLE_COLUMN_EMPHASES = ['standard', 'primary', 'secondary', 'compact'];
export const TABLE_CELL_OVERFLOW_MODES = ['wrap', 'truncate'];

// Story 4-119 — Media Tools. Report-WIDE (unlike everything above this line,
// which is per-SECTION `SectionPresentation`) — the end-of-report "Media
// summary" rollup grid (`ReportMediaSummaryGrid.tsx`, story 4-80/4-81/4-87)
// is one block for the whole report, not a per-section concern, so its
// settings live on `ReportLayout` (`DEFAULT_REPORT_LAYOUT.mediaSummary`
// below) alongside `findingsGroupBy`/`staticBlocks`/`defaultShowEmpty` —
// `4-117`'s own precedent for "a report-wide field goes on `ReportLayout`,
// not the `reportPresentationSchema.ts` client overlay" (see that file's own
// header comment) — rather than a NEW per-section `SectionPresentation`
// field. Deliberately distinct from `SECTION_PRESENTATION`'s own
// `evidencePlacement` (`inline`/`afterResponse`/`gallery`/`appendix`, story
// `4-116`/`4-117`): that property governs where ONE section's OWN inline
// photos render; `mediaSummary.layout` below governs the visual/positional
// treatment of the SEPARATE, whole-report photo rollup block. Both happen to
// use the string `'appendix'` for one of their values — a coincidence of
// wording, not a shared mechanism; see `mediaSummary.layout`'s own comment.
export const MEDIA_SUMMARY_LAYOUTS = ['grid', 'list', 'fullWidth', 'appendix'];
export const MEDIA_SUMMARY_IMAGE_FITS = ['cover', 'contain'];
// "group evidence by question/section/finding" — verified against the real
// data model before assuming all three are buildable (this story's own
// instruction, mirroring `4-117`'s `findingsGroupBy` precedent):
//   * `question` — REAL. A modern (`inspectionEvidence`) photo carries a
//     `fieldId`; `report.service.js#evidenceFieldLabelOf` already resolves it
//     to the field's label against the inspection's pinned schema (the exact
//     mechanism `mediaSummaryOf` already uses for the legacy `roomName`
//     display column). A legacy `rooms[].photos[]` photo answers no
//     question at all — it buckets into an honest "Ungrouped" group rather
//     than being mislabeled with its room name.
//   * `section` — REAL, same mechanism one level up: `field.section.name`
//     (`indexAnswerSchema`'s own field shape, see below) is a real reference
//     every modern evidence photo's field carries. Same "Ungrouped" bucket
//     for a legacy room photo (no field, hence no section) or an
//     evidence photo whose field no longer exists in a re-pinned template.
//   * `finding` — NOT REAL, stays unrealized. `inspectionEvidence.service.js`
//     already has the one real reverse-lookup this codebase uses for "which
//     findings cite this evidence" (`citing = inspection.findings.filter(f =>
//     f.linkedEvidenceIds.includes(...))`) — the reference exists, but it is
//     MANY-TO-MANY: a single photo may be cited by zero, one, or several
//     approved findings. Unlike `question`/`section` (each evidence has AT
//     MOST ONE owning field/section), there is no honest single group a
//     multiply-cited photo belongs to — grouping would need either an
//     arbitrary "first finding wins" pick (dishonest) or one photo appearing
//     in N different groups (a materially different UI mechanic neither
//     `question` nor `section` needs). Deferred for the same class of reason
//     `4-117` deferred `findingsGroupBy: 'status'`/`'assignee'`, not for lack
//     of any reference at all.
export const MEDIA_SUMMARY_GROUP_BY_VALUES = ['none', 'question', 'section', 'finding'];
export const UNREALIZED_MEDIA_SUMMARY_GROUP_BY = new Set(['finding']);

export const DEFAULT_SECTION_PRESENTATION = {
  layout: 'list',
  columns: 'one',
  density: 'comfortable',
  heading: 'visible',
  headingLabel: null,
  repeatHeading: false,
  showEmpty: 'show',
  evidencePlacement: 'inline',
  findingEmphasis: 'standard',
  tableColumns: null,
  overflow: 'wrap',
  showTotalsRow: false,
};

// Layouts/placements/emphases whose RENDER effect this story did not build
// (see the header comment above for why each is a real, honest scoping
// decision, not an oversight) — `resolveSectionPresentation` downgrades a
// stored choice from this set to its real, working default rather than
// silently rendering nothing. `ReportStudioPanels.tsx` is the primary guard
// (it never lets an author pick one of these — disabled with a stated
// reason), this is the defensive second line for data that reaches a render
// some other way (an older build's stored value, a future agent-plane
// write before `4-121` lands).
const UNREALIZED_LAYOUTS = new Set(['groupedList']);
// Story 4-117 — `'appendix'` REALIZED: this story builds the end-of-report
// "Supporting documents" structure `4-116` deferred it for (see that story's
// own DONE annotation) — both renderers now pool a section's photos there
// instead of downgrading the choice to `'inline'`. No longer in this set.
const UNREALIZED_EVIDENCE_PLACEMENTS = new Set([]);
const UNREALIZED_FINDING_EMPHASES = new Set(['highlighted', 'summaryOnly']);

/**
 * Story 4-118 — resolves `presentation.tableColumns` (select/reorder/
 * emphasis) against the table's CURRENT field list. Pure; reconciles a
 * stored list that has drifted from `rawSection.fields` rather than trusting
 * it blindly: a key naming a field the table no longer has is dropped (a
 * deleted field leaves no ghost column); a field the table has gained SINCE
 * the list was saved is appended, visible, standard emphasis (a new table
 * column always shows by default rather than silently vanishing); a
 * duplicate key in the stored list keeps only its first occurrence. Returns
 * `null` for a non-table section (nothing to select/reorder — same
 * "resolved down" shape `repeatHeading` uses).
 *
 * @param {Object} rawSection a stored FormSection; `.fields[].key` is the
 *   identity `tableColumns[].key` references (stable across a label rename,
 *   unlike matching on the column's display label)
 * @param {boolean} isTable the caller's already-resolved `kind === 'table'`
 * @returns {?Array<{key:string, visible:boolean, emphasis:string}>}
 */
function resolveTableColumns(rawSection, isTable) {
  if (!isTable) return null;
  const fields = Array.isArray(rawSection && rawSection.fields) ? rawSection.fields : [];
  const fieldKeys = fields.map((f) => String((f && f.key) || ''));
  const rawList = Array.isArray(rawSection && rawSection.presentation && rawSection.presentation.tableColumns)
    ? rawSection.presentation.tableColumns
    : null;
  if (!rawList) {
    return fieldKeys.map((key) => ({ key, visible: true, emphasis: 'standard' }));
  }
  const seen = new Set();
  const ordered = [];
  rawList.forEach((entry) => {
    const key = entry && typeof entry.key === 'string' ? entry.key : null;
    if (!key || !fieldKeys.includes(key) || seen.has(key)) return;
    seen.add(key);
    ordered.push({
      key,
      visible: entry.visible !== false,
      emphasis: TABLE_COLUMN_EMPHASES.includes(entry.emphasis) ? entry.emphasis : 'standard',
    });
  });
  fieldKeys.forEach((key) => {
    if (seen.has(key)) return;
    seen.add(key);
    ordered.push({ key, visible: true, emphasis: 'standard' });
  });
  return ordered;
}

/**
 * The one place a section's report-presentation properties resolve from a
 * possibly-missing/possibly-unrealized raw value to what a renderer should
 * actually do — shared by both renderers' resolvers
 * (`report.service.js#buildRenderContent`'s answers-section path via
 * `indexAnswerSchema` below, and the frontend editor's own draft preview,
 * `reportPreviewContent.ts`) so neither can drift from the other's
 * defaults/coercions. `pageBreak` is NOT included here — it already has its
 * own, older resolution (`indexAnswerSchema`'s own `pageBreak` local,
 * immediately below); this covers only the 8 fields story 4-116 adds.
 *
 * @param {Object} rawSection a stored FormSection (`.presentation`, if
 *   present, holds the 8 fields; `undefined`/partial is the pre-4-116 norm
 *   and every real case today)
 * @param {string} kind the section's OWN resolved `kind` (the caller already
 *   has this in scope)
 * @param {string} [reportDefaultShowEmpty] Story 4-117 — the report-wide
 *   default (`ReportLayout.defaultShowEmpty`) a section with no explicit
 *   `showEmpty` of its own falls back to, INSTEAD of the hardcoded
 *   `DEFAULT_SECTION_PRESENTATION.showEmpty`. Optional and additive: every
 *   pre-4-117 call site (this file's own `indexAnswerSchema` is the only
 *   real one — see immediately below — plus any hand-built test fixture)
 *   omits it and gets the ORIGINAL, byte-identical resolution (`'show'`).
 *   `indexAnswerSchema` always passes the schema's own resolved
 *   `reportLayoutOf(schema).defaultShowEmpty`, which itself defaults to
 *   `'hide'` — see that field's own `formSchema.d.ts` comment for why
 *   `'hide'`, not `'show'`, is the value that keeps every existing template
 *   byte-identical (a genuinely unanswered field's row is dropped entirely
 *   before it ever reaches presentation — see `inspectionAnswers.service.js
 *   #rowFor`'s own 4-117 comment — so `'hide'` is what today's real behavior
 *   already amounts to, `'show'` was never actually reachable for that case).
 * @returns {Object} fully-resolved, render-ready presentation
 */
export function resolveSectionPresentation(rawSection, kind, reportDefaultShowEmpty) {
  const raw = (rawSection && rawSection.presentation) || {};
  const isTable = kind === 'table';

  let layout = SECTION_LAYOUTS.includes(raw.layout) ? raw.layout : DEFAULT_SECTION_PRESENTATION.layout;
  if (isTable) {
    layout = 'table';
  } else if (layout === 'table' || UNREALIZED_LAYOUTS.has(layout)) {
    layout = DEFAULT_SECTION_PRESENTATION.layout;
  }

  const columns =
    layout === 'list' && SECTION_COLUMNS.includes(raw.columns) ? raw.columns : DEFAULT_SECTION_PRESENTATION.columns;

  const density = SECTION_DENSITIES.includes(raw.density) ? raw.density : DEFAULT_SECTION_PRESENTATION.density;

  const heading = SECTION_HEADING_MODES.includes(raw.heading) ? raw.heading : DEFAULT_SECTION_PRESENTATION.heading;
  const headingLabel =
    heading === 'renamed' && typeof raw.headingLabel === 'string' && raw.headingLabel.trim()
      ? raw.headingLabel.trim()
      : null;

  const repeatHeading = isTable ? raw.repeatHeading === true : false;

  const showEmptyFallback = SHOW_EMPTY_MODES.includes(reportDefaultShowEmpty)
    ? reportDefaultShowEmpty
    : DEFAULT_SECTION_PRESENTATION.showEmpty;
  const showEmpty = SHOW_EMPTY_MODES.includes(raw.showEmpty) ? raw.showEmpty : showEmptyFallback;

  let evidencePlacement = EVIDENCE_PLACEMENTS.includes(raw.evidencePlacement)
    ? raw.evidencePlacement
    : DEFAULT_SECTION_PRESENTATION.evidencePlacement;
  if (UNREALIZED_EVIDENCE_PLACEMENTS.has(evidencePlacement)) {
    evidencePlacement = DEFAULT_SECTION_PRESENTATION.evidencePlacement;
  }

  let findingEmphasis = FINDING_EMPHASES.includes(raw.findingEmphasis)
    ? raw.findingEmphasis
    : DEFAULT_SECTION_PRESENTATION.findingEmphasis;
  if (UNREALIZED_FINDING_EMPHASES.has(findingEmphasis)) {
    findingEmphasis = DEFAULT_SECTION_PRESENTATION.findingEmphasis;
  }

  // Story 4-118 — table-only; see `resolveTableColumns`'s own comment and
  // `DEFAULT_SECTION_PRESENTATION`'s header comment above for the full
  // rationale of each field.
  const tableColumns = resolveTableColumns(rawSection, isTable);
  const overflow = isTable && TABLE_CELL_OVERFLOW_MODES.includes(raw.overflow) ? raw.overflow : DEFAULT_SECTION_PRESENTATION.overflow;
  const showTotalsRow = isTable ? raw.showTotalsRow === true : false;

  return {
    layout,
    columns,
    density,
    heading,
    headingLabel,
    repeatHeading,
    showEmpty,
    evidencePlacement,
    findingEmphasis,
    tableColumns,
    overflow,
    showTotalsRow,
  };
}

/** Story 4-118 — a `ReportTableCell`'s `kind`, tolerating the legacy bare
 * `string` cell shape (a pre-4-83c `tableRows` entry surviving inside a
 * pinned `version.assembledContent` snapshot — see `ReportTableCell`'s own
 * contract comment). */
const tableCellKind = (cell) => (typeof cell === 'string' ? 'text' : (cell && cell.kind) || 'text');
const tableCellText = (cell) => (typeof cell === 'string' ? cell : (cell && cell.value) || '');

/**
 * Story 4-118 — the ONE place a `kind:'table'` section's WIRE `columns`/
 * `columnKeys`/`tableRows` (always the section's full, natural-order field
 * list — content assembly never filters/reorders them, same "derived at
 * render time" approach `evidencePlacement` already established) resolve
 * against the author's `presentation.tableColumns` choice into what a
 * renderer should actually draw: which columns, in what order, with what
 * emphasis. Both `ReportDataTable.tsx` and `pdfExport.service.js#renderDataTable`
 * call this ONE function (via their own runtime's copy of this file) rather
 * than each re-deriving the same filter/reorder/emphasis logic — the one
 * place `4-118`'s own "both renderers agree" requirement is actually
 * enforced, not just documented.
 *
 * `columnKeys` may be `null`/mismatched-length (a pre-4-118 frozen
 * `assembledContent` snapshot, or any hand-built fixture that predates this
 * story) — that is treated the same as "no configuration": natural order,
 * every column, standard emphasis, byte-identical to pre-4-118 rendering.
 * `tableColumns` all-hidden (should not happen — the UI keeps at least one
 * column visible — but a hand-edited/future agent-plane value could) falls
 * back to showing every column rather than rendering a headerless, columnless
 * table shell.
 *
 * Emphasis `'compact'` is automatically relaxed to `'secondary'` for any
 * column that carries a `photo-grid`/`chip` cell anywhere in its own data —
 * the "prevent actions/signatures/images from being compressed into
 * unusable cells" requirement, enforced HERE so it can never be bypassed by
 * a hand-edited or agent-plane `tableColumns` value either.
 *
 * @param {string[]} columns display labels, natural (schema) order
 * @param {?string[]} columnKeys stable field keys, same order/length as `columns`
 * @param {Array<Array<Object|string>>} tableRows one array of cells per row, natural column order
 * @param {?Array<{key:string, visible:boolean, emphasis:string}>} tableColumnsConfig `presentation.tableColumns`
 * @returns {{columns: Array<{label:string, emphasis:string}>, rows: Array<Array<Object|string>>}}
 */
export function resolveTableColumnsView(columns, columnKeys, tableRows, tableColumnsConfig) {
  const cols = Array.isArray(columns) ? columns : [];
  const rows = Array.isArray(tableRows) ? tableRows : [];
  const keys = Array.isArray(columnKeys) && columnKeys.length === cols.length ? columnKeys : null;
  const config = Array.isArray(tableColumnsConfig) ? tableColumnsConfig : null;

  const naturalView = () => ({
    columns: cols.map((label) => ({ label, emphasis: 'standard' })),
    rows: rows.map((row) => row),
  });

  if (!keys || !config) return naturalView();

  const indexByKey = new Map(keys.map((k, i) => [k, i]));
  const known = config.filter((c) => c && indexByKey.has(c.key));
  if (known.length === 0) return naturalView();
  const visible = known.filter((c) => c.visible !== false);
  const finalConfig = visible.length > 0 ? visible : known;

  const orderedRows = rows.map((row) => finalConfig.map((c) => row[indexByKey.get(c.key)]));
  const resolvedColumns = finalConfig.map((c, colIndex) => {
    const protectedContent = orderedRows.some((row) => {
      const kind = tableCellKind(row[colIndex]);
      return kind === 'photo-grid' || kind === 'chip';
    });
    const emphasis = c.emphasis === 'compact' && protectedContent ? 'secondary' : c.emphasis || 'standard';
    return { label: cols[indexByKey.get(c.key)], emphasis };
  });

  return { columns: resolvedColumns, rows: orderedRows };
}

/**
 * Story 4-118 — `presentation.showTotalsRow`'s one aggregate row, derived at
 * RENDER time from the already column-resolved `rows`
 * (`resolveTableColumnsView`'s own output — this never sees the raw,
 * unfiltered wire data), so a hidden column contributes nothing to the
 * totals it would not otherwise be shown for. Pure; `null` for an empty
 * table (nothing to total). Per column:
 *   - every cell is `photo-grid` -> total photo count ("N photos").
 *   - every cell is `chip` -> a count per distinct chip label (a lightweight
 *     compliance/status summary, e.g. "Pass: 3, Fail: 1").
 *   - every non-empty cell parses as a finite number -> the sum.
 *   - otherwise -> blank, except the FIRST column, which anchors the row
 *     with "Total (N rows)" so the row is never entirely blank.
 * @param {Array<Array<Object|string>>} rows column-resolved rows (`resolveTableColumnsView`'s output)
 * @returns {?string[]} one text cell per column, or `null` for zero rows
 */
export function computeTableTotalsRow(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  const colCount = rows[0].length;
  const totals = [];
  for (let c = 0; c < colCount; c += 1) {
    const colCells = rows.map((row) => row[c]);
    const kinds = new Set(colCells.map(tableCellKind));
    if (kinds.size === 1 && kinds.has('photo-grid')) {
      const count = colCells.reduce((sum, cell) => sum + ((cell && cell.photos && cell.photos.length) || 0), 0);
      totals.push(count > 0 ? `${count} photo${count === 1 ? '' : 's'}` : '—');
      continue;
    }
    if (kinds.size === 1 && kinds.has('chip')) {
      const counts = new Map();
      colCells.forEach((cell) => {
        const label = (cell && cell.chip && cell.chip.label) || tableCellText(cell) || 'Unanswered';
        counts.set(label, (counts.get(label) || 0) + 1);
      });
      totals.push([...counts.entries()].map(([label, n]) => `${label}: ${n}`).join(', '));
      continue;
    }
    const values = colCells.map(tableCellText).filter((v) => v !== '');
    const numbers = values.map(Number);
    if (values.length > 0 && numbers.every((n) => Number.isFinite(n))) {
      const sum = numbers.reduce((a, b) => a + b, 0);
      totals.push(String(sum));
      continue;
    }
    totals.push(c === 0 ? `Total (${rows.length} row${rows.length === 1 ? '' : 's'})` : '—');
  }
  return totals;
}

/**
 * The one place "which template sections does the report actually render,
 * and in what order" is decided — shared by both renderers' resolvers
 * (`inspectionAnswers.service.js#buildReportAnswerView`, `report.service.js
 * #tableOfContentsOf`) so the report body and its table of contents can
 * never disagree on either question. Pure: does not mutate `sections`.
 *
 * Works against ANY array of section-like objects that may carry `.hidden`/
 * `.reportOrder` (a raw stored `FormSection`, or an `IndexedSection` — both
 * shapes carry the same two field names) — callers pass whichever list they
 * already have.
 *
 * @param {Array<{id?:string, hidden?:boolean, reportOrder?:number|null}>} sections
 * @returns {Array} the same object references, filtered (no `hidden:true`)
 *   and sorted by `reportOrder` (falling back to original array position for
 *   a section with no explicit order — stable, so untouched sections keep
 *   their relative capture order).
 */
export function orderedVisibleReportSections(sections) {
  const withIndex = (sections || []).map((section, index) => ({ section, index }));
  const visible = withIndex.filter(({ section }) => !(section && section.hidden === true));
  visible.sort((a, b) => {
    const ao = typeof a.section?.reportOrder === 'number' ? a.section.reportOrder : a.index;
    const bo = typeof b.section?.reportOrder === 'number' ? b.section.reportOrder : b.index;
    return ao - bo || a.index - b.index;
  });
  return visible.map(({ section }) => section);
}

// ---------------------------------------------------------------- report layout

export const PAGE_SIZES = ['A4', 'letter'];
export const THUMBNAIL_SIZES = ['small', 'medium', 'large'];
export const PHOTO_RESOLUTIONS = ['standard', 'high'];
// Story 4-84 — 'mono' added (additive; 'sans'/'serif' unchanged so a
// pre-existing saved value keeps resolving exactly as before).
//
// ── Story 4-128f: this comment used to say the opposite of what is true ──
// It recorded that all three values were deliberately SYSTEM/generic stacks
// with "no new @fontsource package", because "the backend PDF renderer has no
// access to the frontend's self-hosted webfonts" — so a webfont could not be
// offered as a font CHOICE without rendering one face on screen and another
// in the PDF.
//
// That premise is gone. There is no backend PDF renderer any more: both hosts
// load the SAME published document artifact, which carries its own pinned
// font bytes (`frontend/src/report-document/styles/fonts.css`). All three
// values now name a packaged, SIL OFL 1.1 family first — Plus Jakarta Sans,
// Source Serif 4 and IBM Plex Mono — with their former platform stacks kept
// behind as the degrade path. That was defect D-11: the unpackaged serif
// stack really did paginate differently on the two hosts (7 pages vs 6),
// which is exactly the failure this comment was written to prevent and could
// not, because naming a font is not packaging one.
export const REPORT_FONTS = ['sans', 'serif', 'mono'];
// filled = tinted bar (DefectSnap default), centered = bold centered heading
// (classic checklist reports), minimal = left-aligned with accent underline.
export const HEADER_STYLES = ['filled', 'centered', 'minimal'];
// Story 4-82: steps `SectionHeading`'s (both renderers) type size around the
// existing per-`headerStyle` defaults — 'md' IS those existing defaults
// unchanged, so a template that never touches this control renders exactly
// as it did before this story.
export const HEADING_SCALES = ['sm', 'md', 'lg'];
// Story 4-85: 'full' is the pre-4-85 look unchanged (a 'minimal' heading's
// border-bottom / a 'filled' heading's tinted bar are both already
// block-level, i.e. full-width); 'text' shrinks either rule to hug only the
// heading's own text. 'centered' draws no rule either way.
export const SECTION_UNDERLINE_WIDTHS = ['full', 'text'];
// Story 4-85: corner treatment for filled/chip surfaces (badges, severity
// chips, the 'filled' section-header background) only. 'rounded' is the
// pre-4-85 look unchanged (those surfaces already hardcoded a 6px radius).
export const SURFACE_RADII = ['rounded', 'sharp'];

// Story 4-120 — Style Tools. Every array below backs one allowlisted
// `ReportStyle` field (`contracts/reports.js` — see that file's own comment
// on each for the full rationale); this file only needs the legal-value
// lists + the byte-identical-default merge, same "guard, don't invent"
// pattern `REPORT_FONTS`/`SECTION_UNDERLINE_WIDTHS`/`SURFACE_RADII` above
// already establish.
export const TYPOGRAPHY_CAPTION_SCALES = ['sm', 'md'];
export const COLOR_ROLE_BRAND_VALUES = ['accent', 'neutral'];
export const COLOR_ROLE_HEADING_VALUES = ['default', 'brand'];
export const COLOR_ROLE_BORDER_VALUES = ['default', 'brand'];
export const COLOR_ROLE_FINDING_SEVERITY_VALUES = ['standard', 'brand'];
export const BORDER_DENSITIES = ['standard', 'bold'];
export const COVER_VARIANTS = ['standard', 'accent'];
export const LETTERHEAD_VARIANTS = ['standard', 'divider'];
export const TABLE_VARIANTS = ['standard', 'striped'];
export const FINDING_VARIANTS = ['standard', 'compact'];

// Story 4-88a — letterhead header/footer slots (P06 §4). A FIXED set of
// seven named slots, not free x/y coordinates (the epic's deliberate
// trade). CamelCased (not the story prose's `logo-left` hyphenated form) —
// see `contracts/reports.js#ReportLetterhead`'s comment: the contract
// codegen emits bare, unquoted object-literal keys, so a hyphenated key
// would be invalid generated TypeScript. One naming scheme everywhere.
export const LETTERHEAD_SLOT_KEYS = [
  'logoLeft', 'logoCenter', 'logoRight',
  'title', 'addressBlock',
  'footerPageNumber', 'footerText',
];

// Each slot's own null-safe default — mirrors `content`'s per-key merge
// below. All OFF by default: a template that never opens the letterhead
// panel resolves every slot to this, so `resolveReportStyle` renders
// byte-identical to before this story existed.
const DEFAULT_LETTERHEAD_SLOT = { enabled: false, content: null };

// Story 4-107 — the repetition-mode field, a sibling to the seven slot keys
// (not one of them, so it is set OUTSIDE the `LETTERHEAD_SLOT_KEYS` loop
// below). `'firstContentPage'` is byte-identical to every pre-4-107 saved
// template: the header slots render once, in-content. See
// `contracts/reports.js#ReportLetterhead`'s own comment for the full
// rationale of the three values.
export const LETTERHEAD_MODES = ['none', 'firstContentPage', 'everyContentPage'];
const DEFAULT_LETTERHEAD_MODE = 'firstContentPage';

// Story 4-115 — letterhead LAYOUT DENSITY: a sibling of `mode`, not one of
// the seven slot keys. 'standard' is byte-identical to every pre-4-115
// render (the exact logo max-height/spacing 4-88a/4-88b already shipped);
// 'compact' is a real, smaller footprint (shorter logo max-height, tighter
// vertical spacing) for templates that want the letterhead to take less of
// the printable page — both renderers apply it via CSS only, no schema
// shape change to any slot.
export const LETTERHEAD_LAYOUTS = ['standard', 'compact'];
const DEFAULT_LETTERHEAD_LAYOUT = 'standard';

// Story 4-115 — a bounded, typed confidentiality marking (never free text —
// "typed schema only" applies here too). 'none' (default) renders nothing,
// byte-identical to every pre-4-115 template. A non-'none' value is only
// ever rendered where a template author opts it INTO a footer slot's own
// content via the `{confidential}` placeholder (resolved since story 4-128e
// by `paginate.ts#buildRunningFooterMarginBoxes`, in the shared document, for
// every host at once) — setting this field alone changes nothing visible until
// that placeholder is actually used, the same "position-only, no effect
// until wired to a slot" shape `title`/`addressBlock` already established.
export const LETTERHEAD_CONFIDENTIALITY_LEVELS = ['none', 'confidential', 'internal', 'restricted'];
const DEFAULT_LETTERHEAD_CONFIDENTIALITY = 'none';
export const LETTERHEAD_CONFIDENTIALITY_LABELS = {
  none: '',
  confidential: 'Confidential',
  internal: 'Internal use only',
  restricted: 'Restricted',
};

export const DEFAULT_LETTERHEAD = {
  ...Object.fromEntries(LETTERHEAD_SLOT_KEYS.map((key) => [key, DEFAULT_LETTERHEAD_SLOT])),
  mode: DEFAULT_LETTERHEAD_MODE,
  // Story 4-115 — three additive fields, same null-safe merge as every
  // field on this object already uses (see `mergeLetterhead` below).
  layout: DEFAULT_LETTERHEAD_LAYOUT,
  confidentiality: DEFAULT_LETTERHEAD_CONFIDENTIALITY,
  // A letterhead-wide optional text color override for the title/address/
  // footer text — `null` (default) means "use the renderer's own default
  // text color", exactly as today; a set value is contrast-checked at save
  // (`backend/src/services/letterheadContrast.js`, story 4-115) before it
  // can ever reach a render.
  textColor: null,
};

export const DEFAULT_REPORT_LAYOUT = {
  logoUrl: '',
  pageSize: 'A4',
  thumbnailSize: 'medium',
  photoResolution: 'standard',
  accentColor: '#6366f1',
  font: 'sans',
  headerStyle: 'filled',
  footerText: 'Generated with DefectSnap',
  // Story 4-82 — expanded report style customization. Additive: a template
  // saved before this story has none of these three keys, so
  // `reportLayoutOf`'s `{ ...DEFAULT_REPORT_LAYOUT, ...r }` merge fills them
  // in from here, same null-safe pattern every existing field already uses.
  coverPage: false,
  headingScale: 'md',
  secondaryTextFromAccent: false,
  // Story 4-85 — two more additive dimensions, same null-safe merge as the
  // three above (a template saved before this story has neither key, so
  // `reportLayoutOf`'s merge fills them in from here).
  sectionUnderlineWidth: 'full',
  surfaceRadius: 'rounded',
  // Story 4-114 — page orientation and a named margin preset, same null-safe
  // merge as every field above. 'portrait'/'normal' are BYTE-IDENTICAL to
  // every pre-4-114 render (`normal` is the exact pre-existing hardcoded
  // `BODY_MARGIN_MM`/`marginsMm` value both renderers already used — see
  // `reportLayoutPolicy.js`'s own comment), so a template that never opens
  // this control renders exactly as it did before this story.
  pageOrientation: 'portrait',
  marginsPreset: 'normal',
  // Story 4-88a — additive: a template saved before this story has no
  // `letterhead` key, so `reportLayoutOf`'s merge (below) fills it in from
  // here, same null-safe pattern every field above already uses.
  letterhead: DEFAULT_LETTERHEAD,
  content: {
    footer: true,
    tableOfContents: false,
    // Story 4-110 — re-scoped to an inert, backward-compat-only field:
    // neither renderer reads it anymore (`ReportContentSection.pageBreak`
    // replaces it, a real per-section property) and the editor's Content
    // tab no longer shows it as a checkbox. Still defaulted/written here so
    // an already-saved template's `report.content` keeps parsing — see
    // `contracts/reports.js#ReportContentToggles`'s own comment for the
    // full "why keep a dead key" rationale.
    pageBreak: true,
    summary: false,
    flaggedItems: true,
    actions: true,
    disclaimer: false,
    inspectionResults: true,
    tables: true,
    mediaSummary: true,
    scores: true,
    // Story 4-117 — Content Tools. See `formSchema.d.ts#ReportContentToggles`'
    // own comment on each field for the full rationale; every default below
    // is the value that keeps a pre-4-117 template's render byte-identical
    // (`false`/`true` chosen per-field to match what already happens today,
    // not a blanket "off"). No `introduction` key here — see that field's
    // own `formSchema.d.ts` comment for why this story does not add one.
    methodology: false,
    showQuestionLabels: true,
    showAnswers: true,
    showDescriptions: false,
    metadata: false,
    includeInternalNotes: false,
    evidenceCaptions: false,
  },
  // Story 4-117 — see `formSchema.d.ts#ReportLayout.defaultShowEmpty`'s own
  // comment for why `'hide'`, not `DEFAULT_SECTION_PRESENTATION.showEmpty`'s
  // `'show'`, is the byte-identical-with-today default here.
  defaultShowEmpty: 'hide',
  // Story 4-117 — additive, null-safe-merged sibling of `letterhead` above
  // (see `mergeStaticBlocks` below); `''` for every field is the pre-4-117
  // "disclaimer toggle exists but has no authored text" state, now also true
  // of `methodology`.
  staticBlocks: { disclaimer: '', methodology: '' },
  // Story 4-117 — see `FindingsGroupBy`'s own `formSchema.d.ts` comment.
  findingsGroupBy: 'severity',
  // Story 4-119 — Media Tools. `layout:'grid'` + `imageFit:'cover'` +
  // `showCaptions:true` are BYTE-IDENTICAL to every pre-4-119 render (the
  // grid always showed a caption, always cropped to a square tile, since
  // `4-81`); `showTimestamps`/`showLocation`/`showAnnotations` all default
  // `false` (none of the three showed anything before this story, `false`
  // is the only default that changes nothing for an existing template);
  // `groupBy:'none'` is today's unchanged flat grid. See
  // `MEDIA_SUMMARY_GROUP_BY_VALUES`'s own comment above for `showLocation`/
  // `showAnnotations` — both round-trip honestly here but resolve to `false`
  // at render time regardless of the stored value
  // (`resolveMediaSummaryPresentation`, `report.service.js`): no per-photo
  // capture-time location exists in this data model (`gps` is its own
  // capture FIELD type, never a per-photo coordinate — see
  // `inspectionEvidence.model.js#evidenceMetadataSchema`, which has no
  // lat/lng at all), and photo annotation data exists ONLY on the legacy,
  // pre-4-83b `rooms[].photos[].annotations` shape whose WRITE surface was
  // fully retired in that story (`inspectionEvidence.model.js`'s own header
  // comment) — historical-only, empty for every photo captured since, not
  // worth a render mechanism.
  mediaSummary: {
    layout: 'grid',
    imageFit: 'cover',
    showCaptions: true,
    showTimestamps: false,
    showLocation: false,
    showAnnotations: false,
    groupBy: 'none',
  },
  // Story 4-120 — Style Tools. Every default below is the exact pre-4-120
  // rendered look (see `contracts/reports.js#ReportStyle`'s own comment on
  // each field for the full rationale) — a template that never opens the
  // new controls renders byte-identically to before this story.
  typographyRoles: { caption: 'sm' },
  colorRoles: { brand: 'accent', heading: 'default', border: 'default', findingSeverity: 'standard' },
  borderDensity: 'standard',
  variants: { cover: 'standard', letterhead: 'standard', table: 'standard', finding: 'standard' },
};

// Story 4-88a — per-slot merge, the same idea as `content`'s merge above but
// one level deeper: a caller that only patches ONE slot (e.g. `{ logoLeft:
// { enabled: true } }`) must not lose that slot's OWN `content` default, nor
// wipe the other six slots back to defaults. Each slot is merged against its
// own default individually rather than the whole `letterhead` object being
// shallow-spread.
function mergeLetterhead(saved) {
  const out = {};
  for (const key of LETTERHEAD_SLOT_KEYS) {
    out[key] = { ...DEFAULT_LETTERHEAD_SLOT, ...(saved?.[key] ?? {}) };
  }
  // Story 4-107 — same null-safe pattern as the per-slot merge above: an
  // invalid/missing `mode` (every pre-4-107 saved template) falls back to
  // the default rather than propagating `undefined` or a stale value.
  out.mode = LETTERHEAD_MODES.includes(saved?.mode) ? saved.mode : DEFAULT_LETTERHEAD_MODE;
  // Story 4-115 — same enum-guard pattern as `mode` immediately above, for
  // the three new sibling fields.
  out.layout = LETTERHEAD_LAYOUTS.includes(saved?.layout) ? saved.layout : DEFAULT_LETTERHEAD_LAYOUT;
  out.confidentiality = LETTERHEAD_CONFIDENTIALITY_LEVELS.includes(saved?.confidentiality)
    ? saved.confidentiality
    : DEFAULT_LETTERHEAD_CONFIDENTIALITY;
  out.textColor = typeof saved?.textColor === 'string' && saved.textColor.trim() ? saved.textColor : null;
  return out;
}

// Story 4-117 — same null-safe per-field merge as `mergeLetterhead` above,
// one level shallower (every field here is a plain string, no nested enum
// guard needed): a caller that only patched ONE block (e.g. `{ disclaimer:
// '...' }`) must not lose the other two's own prior text.
function mergeStaticBlocks(saved) {
  return {
    disclaimer: typeof saved?.disclaimer === 'string' ? saved.disclaimer : '',
    methodology: typeof saved?.methodology === 'string' ? saved.methodology : '',
  };
}

// Story 4-119 — same null-safe per-field merge as `mergeStaticBlocks` above:
// an enum guard per field (falls back to `DEFAULT_MEDIA_SUMMARY`'s own value
// rather than propagating an invalid/missing one), so a caller that only
// patched ONE field (`patchReportLayout({ mediaSummary: { layout: 'list' } })`
// — see `reportStudioCommands.ts#patchReportLayout`'s own nested-merge
// comment) does not lose the other fields' own prior values. Deliberately
// does NOT apply the `UNREALIZED_MEDIA_SUMMARY_GROUP_BY` downgrade — this
// function only validates "is this a legal enum member", the same
// responsibility `reportLayoutOf`'s other merges have; the UNREALIZED->real
// downgrade is a RENDER-time decision (`resolveMediaSummaryPresentation`,
// `report.service.js`, mirroring `resolveFindingsGroupBy`'s own split), so a
// stored `'finding'` still round-trips honestly through the editor/agent
// plane instead of being silently rewritten on every save.
function mergeMediaSummary(saved) {
  const d = DEFAULT_REPORT_LAYOUT.mediaSummary;
  return {
    layout: MEDIA_SUMMARY_LAYOUTS.includes(saved?.layout) ? saved.layout : d.layout,
    imageFit: MEDIA_SUMMARY_IMAGE_FITS.includes(saved?.imageFit) ? saved.imageFit : d.imageFit,
    showCaptions: typeof saved?.showCaptions === 'boolean' ? saved.showCaptions : d.showCaptions,
    showTimestamps: typeof saved?.showTimestamps === 'boolean' ? saved.showTimestamps : d.showTimestamps,
    showLocation: typeof saved?.showLocation === 'boolean' ? saved.showLocation : d.showLocation,
    showAnnotations: typeof saved?.showAnnotations === 'boolean' ? saved.showAnnotations : d.showAnnotations,
    groupBy: MEDIA_SUMMARY_GROUP_BY_VALUES.includes(saved?.groupBy) ? saved.groupBy : d.groupBy,
  };
}

// Story 4-120 — same null-safe per-field merge as `mergeMediaSummary` above:
// an enum guard per field, falling back to `DEFAULT_REPORT_LAYOUT`'s own
// value rather than propagating an invalid/missing one. Three small merges,
// not one flat spread, because `colorRoles`/`typographyRoles`/`variants` are
// each their OWN nested object a caller may patch independently (e.g.
// `patchReportLayout({ colorRoles: { heading: 'brand' } })` must not lose
// `brand`/`border`/`findingSeverity`'s own prior values) — same "merge one
// level deeper than a shallow spread" reasoning `mergeLetterhead`/
// `mergeMediaSummary` already established for their own nested objects.
function mergeTypographyRoles(saved) {
  const d = DEFAULT_REPORT_LAYOUT.typographyRoles;
  return {
    caption: TYPOGRAPHY_CAPTION_SCALES.includes(saved?.caption) ? saved.caption : d.caption,
  };
}
function mergeColorRoles(saved) {
  const d = DEFAULT_REPORT_LAYOUT.colorRoles;
  return {
    brand: COLOR_ROLE_BRAND_VALUES.includes(saved?.brand) ? saved.brand : d.brand,
    heading: COLOR_ROLE_HEADING_VALUES.includes(saved?.heading) ? saved.heading : d.heading,
    border: COLOR_ROLE_BORDER_VALUES.includes(saved?.border) ? saved.border : d.border,
    findingSeverity: COLOR_ROLE_FINDING_SEVERITY_VALUES.includes(saved?.findingSeverity)
      ? saved.findingSeverity
      : d.findingSeverity,
  };
}
function mergeVariants(saved) {
  const d = DEFAULT_REPORT_LAYOUT.variants;
  return {
    cover: COVER_VARIANTS.includes(saved?.cover) ? saved.cover : d.cover,
    letterhead: LETTERHEAD_VARIANTS.includes(saved?.letterhead) ? saved.letterhead : d.letterhead,
    table: TABLE_VARIANTS.includes(saved?.table) ? saved.table : d.table,
    finding: FINDING_VARIANTS.includes(saved?.finding) ? saved.finding : d.finding,
  };
}

// Story 4-117 — `findingsGroupBy` values with no real grouping behind them
// yet (see `FindingsGroupBy`'s own `formSchema.d.ts` comment) — the render-
// time resolver (`report.service.js#resolveFindingsGroupBy`) downgrades any
// of these to `'severity'`, same `UNREALIZED_*` shape `resolveSectionPresentation`
// already uses for `layout`/`evidencePlacement`/`findingEmphasis`.
export const FINDINGS_GROUP_BY_VALUES = ['severity', 'section', 'status', 'assignee'];
export const UNREALIZED_FINDINGS_GROUP_BY = new Set(['section', 'status', 'assignee']);

// Layout with defaults filled in — always read report config through this.
export function reportLayoutOf(schema) {
  // A persisted preset's `schema` is whatever the last save actually wrote —
  // for a template edited through the human editor, that is `toV1(v2)`'s OWN
  // output: `{title, sections, metadata: {..., formSchemaV2: <the real v2
  // object>}}`, so the report-layout config a person configured lives at
  // `schema.metadata.formSchemaV2.report`, never at this parameter's own top
  // level — `schema.report` is simply absent on that shape. Fall back to the
  // embedded copy in that case, same value `TemplateEditorPage`'s own
  // `fromPresetSchema` hydration-on-load already unwraps for the editor
  // (real bug: the report renderer and the editor were reading the SAME
  // persisted object at two different paths and only one of them agreed with
  // what a person saved). Deliberately NOT routed through `fromPresetSchema`
  // itself: that function's fallback branch is `migrateV1`, which does not
  // preserve `report` at all (it exists to synthesize sections from a
  // genuinely pre-v2 schema, not to carry this block through) — every
  // existing caller that already hands this function a bare `{report:{...}}`
  // object with no `version` field (every hand-built test fixture, and any
  // future one) would have had its `report` silently discarded by that
  // route. This fallback only ever ADDS a second place to look; the
  // existing `schema.report` read (already the correct value 99% of the
  // time — every non-persisted caller) is untouched.
  const r = schema?.report ?? schema?.metadata?.formSchemaV2?.report ?? {};
  return {
    ...DEFAULT_REPORT_LAYOUT,
    ...r,
    content: { ...DEFAULT_REPORT_LAYOUT.content, ...(r.content ?? {}) },
    letterhead: mergeLetterhead(r.letterhead),
    // Story 4-117 — same null-safe merge pattern as `content`/`letterhead`
    // immediately above.
    defaultShowEmpty: SHOW_EMPTY_MODES.includes(r.defaultShowEmpty) ? r.defaultShowEmpty : DEFAULT_REPORT_LAYOUT.defaultShowEmpty,
    staticBlocks: mergeStaticBlocks(r.staticBlocks),
    findingsGroupBy: FINDINGS_GROUP_BY_VALUES.includes(r.findingsGroupBy) ? r.findingsGroupBy : DEFAULT_REPORT_LAYOUT.findingsGroupBy,
    // Story 4-119 — same null-safe merge pattern as `content`/`letterhead`/
    // `staticBlocks` above.
    mediaSummary: mergeMediaSummary(r.mediaSummary),
    // Story 4-120 — same null-safe merge pattern as every field above.
    typographyRoles: mergeTypographyRoles(r.typographyRoles),
    colorRoles: mergeColorRoles(r.colorRoles),
    borderDensity: BORDER_DENSITIES.includes(r.borderDensity) ? r.borderDensity : DEFAULT_REPORT_LAYOUT.borderDensity,
    variants: mergeVariants(r.variants),
  };
}

export const newId = () =>
  (globalThis.crypto?.randomUUID?.() ?? `id-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);

export const createEmptySchema = (title = 'Untitled inspection form') => ({
  version: FORM_SCHEMA_VERSION,
  title,
  sections: [],
  relations: [],
  metadata: {},
});

// ---------------------------------------------------------------- helpers

const isAnswered = (v) =>
  v !== undefined && v !== null && v !== '' && !(Array.isArray(v) && v.length === 0);

export function allFields(schema) {
  return (schema.sections ?? []).flatMap(s => s.fields ?? []);
}

export function findField(schema, ref) {
  return allFields(schema).find(f => f.id === ref || f.key === ref);
}

export function findSection(schema, ref) {
  return (schema.sections ?? []).find(s => s.id === ref || s.name === ref);
}

// ---------------------------------------------------------------- validation

const err = (list, cond, msg) => { if (cond) list.push(msg); };

export function validateCondition(cond, schema, where, errors) {
  if (!cond || typeof cond !== 'object') { errors.push(`${where}: condition must be an object`); return; }
  err(errors, !CONDITION_OPS.includes(cond.op), `${where}: unknown op "${cond.op}"`);
  err(errors, !findField(schema, cond.field), `${where}: references unknown field "${cond.field}"`);
  const needsValue = !['answered', 'notAnswered'].includes(cond.op);
  err(errors, needsValue && cond.value === undefined, `${where}: op "${cond.op}" needs a value`);
}

export function validateFormSchema(schema) {
  const errors = [];
  if (!schema || typeof schema !== 'object') return ['schema must be an object'];
  err(errors, typeof schema.title !== 'string' || schema.title.length === 0, 'title is required');
  err(errors, !Array.isArray(schema.sections), 'sections must be an array');
  if (errors.length > 0) return errors;

  const seenKeys = new Set();
  const tableCount = schema.sections.filter(s => s.kind === 'table').length;
  err(errors, tableCount > MAX_TABLES, `templates support at most ${MAX_TABLES} tables (got ${tableCount})`);
  schema.sections.forEach((section, si) => {
    const sw = `sections[${si}]`;
    err(errors, typeof section.name !== 'string' || !section.name, `${sw}: name is required`);
    err(errors, !Array.isArray(section.fields), `${sw}: fields must be an array`);
    err(errors, section.kind !== undefined && !SECTION_KINDS.includes(section.kind),
      `${sw}: kind must be one of ${SECTION_KINDS.join(', ')}`);
    // Story 4-110 — optional; a missing value resolves per-kind at read
    // time (`indexAnswerSchema` below), not here — this only rejects a
    // present-but-invalid value.
    err(errors, section.pageBreak !== undefined && !PAGE_BREAKS.includes(section.pageBreak),
      `${sw}: pageBreak must be one of ${PAGE_BREAKS.join(', ')}`);
    // Story 4-114 — same "optional; a missing value resolves at read time,
    // this only rejects a present-but-invalid value" pattern as `pageBreak`
    // immediately above.
    err(errors, section.hidden !== undefined && typeof section.hidden !== 'boolean',
      `${sw}: hidden must be a boolean`);
    err(errors, section.reportOrder !== undefined && section.reportOrder !== null && typeof section.reportOrder !== 'number',
      `${sw}: reportOrder must be a number or null`);
    // Story 4-116 — same "optional; a missing value resolves at read time
    // (`resolveSectionPresentation`), this only rejects a present-but-
    // invalid value" pattern as `pageBreak`/`hidden`/`reportOrder` above.
    // Deliberately permissive about the "unrealized" enum members
    // (`layout:'groupedList'`, `evidencePlacement:'appendix'`,
    // `findingEmphasis:'highlighted'|'summaryOnly'`) — those are VALID
    // stored values (the UI just does not offer them), not schema errors;
    // `resolveSectionPresentation` downgrades them at render time.
    if (section.presentation !== undefined) {
      const p = section.presentation;
      const pw = `${sw}.presentation`;
      err(errors, typeof p !== 'object' || p === null, `${pw}: must be an object`);
      if (p && typeof p === 'object') {
        err(errors, p.layout !== undefined && !SECTION_LAYOUTS.includes(p.layout),
          `${pw}.layout must be one of ${SECTION_LAYOUTS.join(', ')}`);
        err(errors, p.columns !== undefined && !SECTION_COLUMNS.includes(p.columns),
          `${pw}.columns must be one of ${SECTION_COLUMNS.join(', ')}`);
        err(errors, p.density !== undefined && !SECTION_DENSITIES.includes(p.density),
          `${pw}.density must be one of ${SECTION_DENSITIES.join(', ')}`);
        err(errors, p.heading !== undefined && !SECTION_HEADING_MODES.includes(p.heading),
          `${pw}.heading must be one of ${SECTION_HEADING_MODES.join(', ')}`);
        err(errors, p.headingLabel !== undefined && p.headingLabel !== null && typeof p.headingLabel !== 'string',
          `${pw}.headingLabel must be a string or null`);
        err(errors, p.repeatHeading !== undefined && typeof p.repeatHeading !== 'boolean',
          `${pw}.repeatHeading must be a boolean`);
        err(errors, p.showEmpty !== undefined && !SHOW_EMPTY_MODES.includes(p.showEmpty),
          `${pw}.showEmpty must be one of ${SHOW_EMPTY_MODES.join(', ')}`);
        err(errors, p.evidencePlacement !== undefined && !EVIDENCE_PLACEMENTS.includes(p.evidencePlacement),
          `${pw}.evidencePlacement must be one of ${EVIDENCE_PLACEMENTS.join(', ')}`);
        err(errors, p.findingEmphasis !== undefined && !FINDING_EMPHASES.includes(p.findingEmphasis),
          `${pw}.findingEmphasis must be one of ${FINDING_EMPHASES.join(', ')}`);
        // Story 4-118 — same "optional; a missing/invalid value resolves at
        // read time" pattern as every field above. `tableColumns` entries are
        // permissive about `key` (not checked against this section's own
        // current field list here — `resolveTableColumns` reconciles that at
        // READ time, same "author's stored choice preserved through
        // validation, only the RESOLVER downgrades/reconciles it" precedent
        // `layout`/`evidencePlacement`/`findingEmphasis` already establish).
        err(errors, p.tableColumns !== undefined && p.tableColumns !== null && !Array.isArray(p.tableColumns),
          `${pw}.tableColumns must be an array or null`);
        if (Array.isArray(p.tableColumns)) {
          p.tableColumns.forEach((c, ci) => {
            const cw = `${pw}.tableColumns[${ci}]`;
            err(errors, typeof c !== 'object' || c === null, `${cw}: must be an object`);
            if (c && typeof c === 'object') {
              err(errors, typeof c.key !== 'string' || !c.key, `${cw}.key is required`);
              err(errors, c.visible !== undefined && typeof c.visible !== 'boolean', `${cw}.visible must be a boolean`);
              err(errors, c.emphasis !== undefined && !TABLE_COLUMN_EMPHASES.includes(c.emphasis),
                `${cw}.emphasis must be one of ${TABLE_COLUMN_EMPHASES.join(', ')}`);
            }
          });
        }
        err(errors, p.overflow !== undefined && !TABLE_CELL_OVERFLOW_MODES.includes(p.overflow),
          `${pw}.overflow must be one of ${TABLE_CELL_OVERFLOW_MODES.join(', ')}`);
        err(errors, p.showTotalsRow !== undefined && typeof p.showTotalsRow !== 'boolean',
          `${pw}.showTotalsRow must be a boolean`);
      }
    }
    (section.visibleWhen ?? []).forEach((c, ci) => validateCondition(c, schema, `${sw}.visibleWhen[${ci}]`, errors));
    (section.fields ?? []).forEach((field, fi) => {
      const fw = `${sw}.fields[${fi}]`;
      err(errors, typeof field.key !== 'string' || !field.key, `${fw}: key is required`);
      err(errors, seenKeys.has(field.key), `${fw}: duplicate key "${field.key}"`);
      seenKeys.add(field.key);
      err(errors, typeof field.label !== 'string' || !field.label, `${fw}: label is required`);
      err(errors, !FIELD_TYPES.includes(field.type), `${fw}: unknown type "${field.type}"`);
      if (['select', 'multiselect'].includes(field.type)) {
        err(errors, !Array.isArray(field.options) || field.options.length === 0,
          `${fw}: ${field.type} needs a non-empty options array (a response set)`);
      }
      if (field.type === 'rating') {
        err(errors, field.min == null || field.max == null || field.min >= field.max,
          `${fw}: rating needs numeric min < max`);
      }
      (field.visibleWhen ?? []).forEach((c, ci) => validateCondition(c, schema, `${fw}.visibleWhen[${ci}]`, errors));
      (field.requirements ?? []).forEach((r, ri) => {
        validateCondition(r?.when, schema, `${fw}.requirements[${ri}].when`, errors);
        (r?.effects ?? []).forEach(e =>
          err(errors, !EFFECTS.includes(e), `${fw}.requirements[${ri}]: unknown effect "${e}"`));
        // effects may be empty: a rule can exist purely to anchor nested
        // follow-up questions ("Ask questions" trigger).
        err(errors, !Array.isArray(r?.effects), `${fw}.requirements[${ri}]: effects must be an array`);
      });
    });
  });

  (schema.relations ?? []).forEach((rel, ri) => {
    const rw = `relations[${ri}]`;
    if (!RELATION_TYPES.includes(rel?.type)) { errors.push(`${rw}: unknown relation type "${rel?.type}"`); return; }
    if (rel.type === 'dependsOn') {
      err(errors, !findField(schema, rel.field), `${rw}: unknown field "${rel.field}"`);
      err(errors, !findField(schema, rel.on), `${rw}: unknown field "${rel.on}"`);
      err(errors, rel.field === rel.on, `${rw}: a field cannot depend on itself`);
    } else {
      err(errors, !Array.isArray(rel.fields) || rel.fields.length < 2, `${rw}: ${rel.type} needs >= 2 fields`);
      (rel.fields ?? []).forEach(f => err(errors, !findField(schema, f), `${rw}: unknown field "${f}"`));
    }
  });

  return errors;
}

// ---------------------------------------------------------------- evaluation

// Loose equality across primitive types: some model providers can only emit
// condition values as strings, so "true" must match true and "3" match 3.
const looseEq = (a, b) => a === b || (a != null && b != null && String(a) === String(b));

export function evaluateCondition(cond, answers, schema) {
  const field = findField(schema, cond.field);
  const v = field ? answers[field.key] : undefined;
  const num = Number(cond.value);
  switch (cond.op) {
    case 'answered': return isAnswered(v);
    case 'notAnswered': return !isAnswered(v);
    case 'eq': return looseEq(v, cond.value);
    case 'neq': return !looseEq(v, cond.value);
    case 'in': return Array.isArray(cond.value)
      ? cond.value.some(x => looseEq(v, x))
      : String(cond.value ?? '').split(',').some(x => looseEq(v, x.trim()));
    case 'gt': return typeof v === 'number' && !Number.isNaN(num) && v > num;
    case 'gte': return typeof v === 'number' && !Number.isNaN(num) && v >= num;
    case 'lt': return typeof v === 'number' && !Number.isNaN(num) && v < num;
    case 'lte': return typeof v === 'number' && !Number.isNaN(num) && v <= num;
    default: return false;
  }
}

const allHold = (conds, answers, schema) =>
  (conds ?? []).every(c => evaluateCondition(c, answers, schema));

// Returns the live state of a form given current answers:
// which fields are visible/required, which need note/photo/action, and any
// relation violations (xor / union / allOf / dependsOn).
export function evaluateForm(schema, answers = {}) {
  const visible = {};
  const required = {};
  const noteRequired = {};
  const photoRequired = {};
  const actionRequired = {};
  const violations = [];

  for (const section of schema.sections ?? []) {
    const sectionVisible = allHold(section.visibleWhen, answers, schema);
    for (const field of section.fields ?? []) {
      const fieldVisible = sectionVisible && allHold(field.visibleWhen, answers, schema);
      visible[field.key] = fieldVisible;
      required[field.key] = Boolean(field.required) && fieldVisible;
      for (const rule of field.requirements ?? []) {
        if (!fieldVisible || !evaluateCondition(rule.when, answers, schema)) continue;
        for (const effect of rule.effects ?? []) {
          if (effect === 'require') required[field.key] = true;
          if (effect === 'requireNote') noteRequired[field.key] = true;
          if (effect === 'requirePhoto') photoRequired[field.key] = true;
          if (effect === 'requireAction') actionRequired[field.key] = true;
        }
      }
    }
  }

  const keyOf = (ref) => findField(schema, ref)?.key ?? ref;
  for (const rel of schema.relations ?? []) {
    if (rel.type === 'dependsOn') {
      const fieldKey = keyOf(rel.field);
      const onKey = keyOf(rel.on);
      if (isAnswered(answers[fieldKey]) && !isAnswered(answers[onKey])) {
        violations.push({ relation: rel, message: `"${fieldKey}" requires "${onKey}" to be answered first` });
      }
      continue;
    }
    const keys = (rel.fields ?? []).map(keyOf).filter(k => visible[k] !== false);
    const answered = keys.filter(k => isAnswered(answers[k]));
    if (rel.type === 'xor' && answered.length !== 1) {
      violations.push({ relation: rel, message: `exactly one of [${keys.join(', ')}] must be answered (got ${answered.length})` });
    }
    if (rel.type === 'union' && answered.length === 0) {
      violations.push({ relation: rel, message: `at least one of [${keys.join(', ')}] must be answered` });
    }
    if (rel.type === 'allOf' && answered.length > 0 && answered.length < keys.length) {
      violations.push({ relation: rel, message: `[${keys.join(', ')}] must be answered together` });
    }
  }

  return { visible, required, noteRequired, photoRequired, actionRequired, violations };
}

// ------------------------------------------------- row-aware answer-set evaluation
//
// `evaluateForm` above answers in the schema's KEY space and has no ROW dimension:
// it is the rule engine, and a repeat row is not a rule, it is a context. The two
// functions below add that context — and they live HERE, in the shared module,
// rather than in either runtime, because P05 §9.5 makes client and server run
// "identical FormSchema v2 rules" and §9.2 makes the capture screen render
// "through the shared `evaluateForm` engine". A second copy of the row-overlay
// recipe in the browser would be exactly the drift that sentence forbids.
// (Story 5-10a wrote them inside `backend/src/services/inspectionAnswers.service.js`
// when the browser had no capture surface to share them with; story 5-10b built
// that surface and moved them here. The backend service now delegates.)

/** The composite identity of one answer: stable field id + the repeat row it
 * belongs to (null outside a repeatable section). Joined with a NUL escape,
 * which cannot occur in either half — so the composite is never ambiguous. */
export function answerKeyOf(fieldId, instanceId) {
  return `${fieldId}\u0000${instanceId == null ? '' : instanceId}`;
}

/** A repeat block is either an explicit `repeat: true` section or a `kind:'table'`
 * one — FormSchema v2 spells the same product idea two ways. Both are read, so a
 * template authored either way captures rows. */
export function isRepeatableSection(section) {
  return Boolean(section && (section.repeat === true || section.kind === 'table'));
}

/** The stable identity of a field. `id` is generated once and never reused; `key`
 * is the author's handle and the evaluator's key space. A hand-written schema may
 * carry no `id`, hence the fallback — stable for as long as the pin is frozen. */
export function fieldIdOf(field) {
  return String((field && (field.id || field.key)) || '');
}

/** The stable identity of a section. Same reasoning, same fallback order. */
export function sectionIdOf(section, index) {
  return String((section && (section.id || section.name)) || `section-${index}`);
}

/**
 * Flatten a FormSchema v2 document into the lookups the capture paths need.
 * Built once and passed down rather than re-walked: a 500-change batch against a
 * 300-field template would otherwise be 150,000 linear scans.
 *
 * @param {Object} schema FormSchema v2
 * @returns {{sections:Array, bySectionId:Map, byFieldId:Map, tableFieldKeys:Set}}
 */
export function indexAnswerSchema(schema) {
  const sections = [];
  const bySectionId = new Map();
  const byFieldId = new Map();
  const tableFieldKeys = new Set();
  // Story 4-117 — the report-wide default `resolveSectionPresentation` below
  // falls back to when a section has no explicit `showEmpty` of its own; see
  // that function's own comment on the 3rd argument.
  const reportDefaultShowEmpty = reportLayoutOf(schema).defaultShowEmpty;

  ((schema && schema.sections) || []).forEach((rawSection, si) => {
    const id = sectionIdOf(rawSection, si);
    const repeatable = isRepeatableSection(rawSection);
    // Carried through so the report render-model (story 4-81) can tell a
    // `table`-kind section apart from an ordinary repeat-row section (both
    // are `repeatable`, but only `table` should render as a real `<table>`)
    // and a `page`-kind section apart from either (a page-break marker, no
    // fields of its own to speak of).
    const kind = SECTION_KINDS.includes(rawSection && rawSection.kind) ? rawSection.kind : 'section';
    // Story 4-110 — same "carried through so the report render-model can
    // read it" reasoning as `kind` immediately above. A section authored
    // before this story (or with the field simply never touched) has no
    // `pageBreak` at all — resolved here exactly the way
    // `report.service.js#buildRenderContent` and both renderers resolve a
    // MISSING value on an already-frozen `assembledContent` section: a
    // `kind:'page'` section defaults to `'always'` (today's real break
    // behavior, unchanged), everything else to `'auto'` (today's default,
    // unchanged) — see `contracts/reports.js#ReportContentSection
    // .pageBreak`'s own comment for the full migration rationale.
    const pageBreak = PAGE_BREAKS.includes(rawSection && rawSection.pageBreak)
      ? rawSection.pageBreak
      : (kind === 'page' ? 'always' : 'auto');
    // Story 4-114 — carried through for the exact same reason `kind`/
    // `pageBreak` are: so `buildReportAnswerView` (via
    // `orderedVisibleReportSections`) can filter/reorder the report's own
    // section list without a second, competing definition of either field.
    const hidden = Boolean(rawSection && rawSection.hidden === true);
    const reportOrder = typeof (rawSection && rawSection.reportOrder) === 'number' ? rawSection.reportOrder : null;
    // Story 4-116 — carried through for the exact same reason `pageBreak`/
    // `hidden`/`reportOrder` are: so `buildReportAnswerView` can pass a
    // fully-resolved presentation straight through to the render model
    // without a second, competing definition.
    const presentation = resolveSectionPresentation(rawSection, kind, reportDefaultShowEmpty);
    const section = {
      id,
      name: String((rawSection && rawSection.name) || `Section ${si + 1}`),
      repeatable,
      kind,
      pageBreak,
      hidden,
      reportOrder,
      presentation,
      fields: [],
    };
    ((rawSection && rawSection.fields) || []).forEach((rawField) => {
      const field = {
        id: fieldIdOf(rawField),
        key: String((rawField && rawField.key) || fieldIdOf(rawField)),
        label: String((rawField && rawField.label) || (rawField && rawField.key) || 'Question'),
        type: String((rawField && rawField.type) || ''),
        raw: rawField,
        section,
      };
      if (!field.id) return;
      section.fields.push(field);
      // FIRST wins on a duplicate id: a schema with two fields sharing an id is
      // already an integrity fault, and the alternative (last wins) would make
      // which answer a client can address depend on section order.
      if (!byFieldId.has(field.id)) byFieldId.set(field.id, field);
      if (repeatable) tableFieldKeys.add(field.key);
    });
    sections.push(section);
    if (!bySectionId.has(id)) bySectionId.set(id, section);
  });

  return { sections, bySectionId, byFieldId, tableFieldKeys };
}

/** Is a value answered, per the evaluator's own rule (never a local copy)? */
const answeredInContext = (schema, fieldKey, answers) =>
  evaluateCondition({ op: 'answered', field: fieldKey }, answers, schema);

/**
 * The full evaluation summary of one answer set: per (field, row) state, relation
 * violations, required-completion and the retained-but-hidden answers. The wire
 * shape is the `AnswerEvaluation` of `contracts/inspections.js`, plus a
 * non-serialisable `stateByKey` lookup the callers use to stamp `hidden`.
 *
 * A repeat row is evaluated by running `evaluateForm` again with that row's
 * answers overlaid on the base ones. That is the honest reading of the engine
 * rather than a second engine that understands rows: one row's "No" must trigger
 * that row's required note without triggering the row below's.
 *
 * @param {{schema:Object, index?:Object, answers:Array, repeats?:Array}} args
 * @returns {Object}
 */
export function evaluateAnswerSet({ schema, index, answers, repeats }) {
  const idx = index || indexAnswerSchema(schema);
  const rows = repeats || [];
  const entries = answers || [];

  // The base context: every answer that is not inside a repeat row.
  const baseAnswers = {};
  entries.forEach((a) => {
    if (a.instanceId != null) return;
    const field = idx.byFieldId.get(a.fieldId);
    if (field) baseAnswers[field.key] = a.value;
  });

  const rowsBySection = new Map(rows.map((r) => [r.sectionId, r.instances || []]));
  const byAnswerKey = new Map(entries.map((a) => [answerKeyOf(a.fieldId, a.instanceId), a]));

  const base = evaluateForm(schema, baseAnswers);
  const fields = [];

  const pushState = (field, instanceId, verdicts, contextAnswers) => {
    fields.push({
      fieldId: field.id,
      fieldKey: field.key,
      sectionId: field.section.id,
      sectionName: field.section.name,
      instanceId: instanceId == null ? null : instanceId,
      label: field.label,
      type: field.type,
      visible: verdicts.visible[field.key] !== false,
      required: Boolean(verdicts.required[field.key]),
      noteRequired: Boolean(verdicts.noteRequired[field.key]),
      photoRequired: Boolean(verdicts.photoRequired[field.key]),
      actionRequired: Boolean(verdicts.actionRequired[field.key]),
      answered: answeredInContext(schema, field.key, contextAnswers),
    });
  };

  idx.sections.forEach((section) => {
    if (!section.repeatable) {
      section.fields.forEach((field) => pushState(field, null, base, baseAnswers));
      return;
    }
    // A repeatable section with no rows asks nothing: there is no row to answer,
    // so none of its fields is required. Whether an EMPTY table should itself be
    // a submit blocker is a submission question, and story 5-10e owns it.
    (rowsBySection.get(section.id) || []).forEach((instanceId) => {
      const rowAnswers = { ...baseAnswers };
      section.fields.forEach((field) => {
        const stored = byAnswerKey.get(answerKeyOf(field.id, instanceId));
        rowAnswers[field.key] = stored ? stored.value : undefined;
      });
      const verdicts = evaluateForm(schema, rowAnswers);
      section.fields.forEach((field) => pushState(field, instanceId, verdicts, rowAnswers));
    });
  });

  // Relations are declared at SCHEMA level by field key and therefore have no row
  // dimension. A relation reaching into a repeatable section would evaluate
  // against an empty base context and report a violation no row could fix, so
  // those are dropped rather than reported as noise. 5-10e owns submit-time
  // validation and may give them a row-aware reading.
  const keyOfRef = (ref) => {
    const found = findField(schema, ref);
    return found ? found.key : ref;
  };
  const violations = [];
  (base.violations || []).forEach((v) => {
    const rel = v.relation || {};
    const relFields = rel.type === 'dependsOn' ? [rel.field, rel.on] : rel.fields || [];
    const keys = relFields.map(keyOfRef);
    if (keys.some((k) => idx.tableFieldKeys.has(k))) return;
    violations.push({ type: String(rel.type || 'relation'), message: String(v.message || ''), fields: keys });
  });

  // P05 §9.1: hidden answers are "excluded from completion, validation, and report
  // output until visible again" — so only VISIBLE requireds are counted, and a
  // question hidden by logic can never block anybody.
  const requiredStates = fields.filter((f) => f.visible && f.required);
  const missing = requiredStates
    .filter((f) => !f.answered)
    .map((f) => ({
      fieldId: f.fieldId,
      fieldKey: f.fieldKey,
      sectionId: f.sectionId,
      instanceId: f.instanceId,
      label: f.label,
    }));

  const stateByKey = new Map(fields.map((f) => [answerKeyOf(f.fieldId, f.instanceId), f]));
  // Retained, and named. "Retained" is invisible by construction, and a client
  // that could not see the retention would have no way to tell it from data loss.
  const hiddenAnswers = entries
    .filter((a) => {
      const state = stateByKey.get(answerKeyOf(a.fieldId, a.instanceId));
      return state ? !state.visible : false;
    })
    .map((a) => ({ fieldId: a.fieldId, instanceId: a.instanceId == null ? null : a.instanceId }));

  return {
    fields,
    violations,
    completion: {
      requiredTotal: requiredStates.length,
      requiredAnswered: requiredStates.length - missing.length,
      complete: missing.length === 0 && violations.length === 0,
      missing,
    },
    hiddenAnswers,
    // Not on the wire — callers use it to stamp `hidden` per stored answer.
    stateByKey,
  };
}

// ---------------------------------------------------------------- migration

const V1_TO_TYPE = { string: 'text', number: 'number', boolean: 'boolean', array: 'multiselect', object: 'textarea' };
const TYPE_TO_V1 = {
  text: 'string', textarea: 'string', number: 'number', boolean: 'boolean',
  select: 'string', multiselect: 'array', rating: 'number', date: 'string',
  datetime: 'string', photo: 'array', signature: 'string', gps: 'object', instruction: 'string',
};

// Legacy ReportSchema (v1) -> FormSchema v2
//
// ── Ids are DETERIVED, never minted (story 5-10e finding) ──────────────────
// `fromPresetSchema` — the ONLY caller — is a READ-TIME view over a v1
// document (`inspectionAnswers.service.js#pinnedSchemaOf` calls it on every
// request; there is no "migrate once, persist the result" caller anywhere in
// the tree, confirmed by grep). `newId()` used to be called here, which meant
// every single read minted a FRESH random id per section/field — so the
// exact same input produced a DIFFERENT schema identity on every call. Two
// requests five milliseconds apart (a GET then the PATCH it informs) would
// disagree about what a field is CALLED, and the PATCH would refuse the
// client's own just-read id as unknown. That made every legacy-shaped
// (pre-v2-editor) template's questions structurally unanswerable — not a
// theoretical risk: confirmed live against the e2e canonical template, whose
// pin has no `metadata.formSchemaV2` and goes through exactly this path.
// `id` is now DERIVED from the same source data every time — `key` for a
// field (its one required, author-stable handle) and `name` for a section,
// with the same `section-${index}` fallback `sectionIdOf` already uses when
// even that is absent — so calling this twice on the same v1 document is the
// same schema both times, exactly like the v2-authored path already is.
export function migrateV1(v1) {
  return {
    version: FORM_SCHEMA_VERSION,
    title: v1?.title ?? 'Untitled inspection form',
    sections: (v1?.sections ?? []).map((s, si) => ({
      id: s.id || s.name || `section-${si}`,
      name: s.name,
      description: s.description,
      // ── Story 4-128f (defect D-5) — carried through, not dropped ────────
      // `orderedVisibleReportSections` reads exactly these two fields to decide
      // which sections the REPORT renders and in what order, and BOTH report
      // consumers reach their section list through `fromPresetSchema`, i.e.
      // through this function whenever a preset has no embedded v2 schema:
      // `inspectionAnswers.service.js#pinnedSchemaOf` for the body, and — since
      // 4-128f — `report.service.js#tableOfContentsOf` for the table of
      // contents. Dropping them here made this migration LOSSIER than reading
      // the raw v1 array, so a legacy-shaped preset that really does carry
      // `hidden`/`reportOrder` silently rendered a section it was told to hide
      // and ignored the report order it was given.
      //
      // Preserved by REFERENCE, null-safely: a v1 document that never had them
      // (the overwhelmingly common case — the v1 editor could not set either)
      // produces `undefined` for both, exactly as before, and
      // `orderedVisibleReportSections`'s own guards already treat that as
      // "visible, capture order". So this is additive in the strict sense:
      // it changes no output for any input that used to have one.
      hidden: s.hidden,
      reportOrder: s.reportOrder,
      fields: (s.fields ?? []).map(f => ({
        id: f.id || f.key,
        key: f.key,
        label: f.label,
        type: V1_TO_TYPE[f.dataType] ?? 'text',
        description: f.description,
        required: Boolean(f.required),
      })),
    })),
    relations: [],
    metadata: { ...(v1?.metadata ?? {}), migratedFromV1: true },
  };
}

// FormSchema v2 -> legacy ReportSchema shape the existing backend accepts.
// The full v2 schema rides along in metadata.formSchemaV2 so nothing is lost.
export function toV1(schema) {
  return {
    title: schema.title,
    sections: (schema.sections ?? []).map(s => ({
      name: s.name,
      description: s.description,
      fields: (s.fields ?? []).filter(f => f.type !== 'instruction').map(f => ({
        key: f.key,
        label: f.label,
        dataType: TYPE_TO_V1[f.type] ?? 'string',
        description: f.description,
        required: Boolean(f.required),
      })),
    })),
    metadata: { ...(schema.metadata ?? {}), formSchemaV2: schema },
  };
}

// Read a preset's schema at the richest available version.
export function fromPresetSchema(v1OrWrapped) {
  const embedded = v1OrWrapped?.metadata?.formSchemaV2;
  if (embedded?.version === FORM_SCHEMA_VERSION) return embedded;
  if (v1OrWrapped?.version === FORM_SCHEMA_VERSION) return v1OrWrapped;
  return migrateV1(v1OrWrapped);
}
